<template>
   <div style="height: 100vh; background: #fff;">
      <!-- 自定义导航栏 -->
      <div
       v-if="client == 'app'&&isFull=='nofull'"
      :style="`
        padding-top: 12vw;
        background: #fff;
        width: 100vw;
        height: 13vw;
        display: flex;
        align-items: center;
      `">
      <!-- 返回按钮 -->
      <div
        :style="`
          width: 10vw;
          height: 100%;
          display: flex;
          background: #fff;
          align-items: center;
          justify-content: center;
        `"
        @click="goBack"
      >
       

      <svg t="1740385178590" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7758" width="20" height="20"><path d="M710.153924 8.980397L266.007127 460.692524a81.118646 81.118646 0 0 0 0.861532 114.476097l446.192936 441.050666a26.922883 26.922883 0 0 0 37.853573-38.284339L304.722232 536.884282a27.27288 27.27288 0 0 1-0.323074-38.445877L748.545955 46.726278A26.922883 26.922883 0 1 0 710.180847 9.00732z" fill="#333333" p-id="7759"></path></svg>

      </div>
      <!-- 标题 -->
      <div
        :style="`
          flex: 1;
          text-align: center;
          color: #333;
          font-size: 17px;
          
        `"
      >
        <span>{{ title }}</span>
      </div>

      <!-- 右侧 -->
      <div style="width: 10vw;"></div>
    </div>

    

  <div id="devicePlayer" v-loading="isLoging">
    <!-- <div style="border: 1px solid red; height: 10vw;"></div> -->
    <!-- <el-dialog title="视频播放" top="0" :close-on-click-modal="false" :visible.sync="showVideoDialog" @close="close()" v-if="showVideoDialog"> -->
      <div style="width: 100%; height: 100%">
            <jessibucaPlayer  ref="jessibuca" :visible.sync="showVideoDialog"
                             :videoUrl="videoUrl" :error="videoError" :message="videoError"
                             :hasAudio="hasAudio" fluent autoplay live :isMobile="true"></jessibucaPlayer>
      </div> 
      <div id="shared" style="text-align: right;">
        <el-tabs v-model="tabActiveName" @tab-click="tabHandleClick" style="padding:2vw;">
          <!--{"code":0,"data":{"paths":["22-29-30.mp4"],"rootPath":"/home/kkkkk/Documents/ZLMediaKit/release/linux/Debug/www/record/hls/kkkkk/2020-05-11/"}}-->
          <!--===========云台控制部分开始======-->
          <!-- <el-tab-pane label="云台控制" name="control" v-if="showPtz" > -->
            <!-- 包裹层 -->
              <div style="display: flex; justify-content: center; align-items: center;">
                <!-- =======控制圆圈部分开始 -->
                <div class="control-wrapper" >
                  <div class="control-btn control-top" @touchstart="ptzCamera('up')" @touchend="ptzCamera('stop')">
                    <i class="el-icon-caret-top"></i>
                    <div class="control-inner-btn control-inner"></div>
                  </div>
                  <div class="control-btn control-left" @touchstart="ptzCamera('left')" @touchend="ptzCamera('stop')">
                    <i class="el-icon-caret-left"></i>
                    <div class="control-inner-btn control-inner"></div>
                  </div>
                  <div class="control-btn control-bottom" @touchstart="ptzCamera('down')" @touchend="ptzCamera('stop')">
                    <i class="el-icon-caret-bottom"></i>
                    <div class="control-inner-btn control-inner"></div>
                  </div>
                  <div class="control-btn control-right" @touchstart="ptzCamera('right')" @touchend="ptzCamera('stop')">
                    <i class="el-icon-caret-right"></i>
                    <div class="control-inner-btn control-inner"></div>
                  </div>
                  <div class="control-round">
                    <div class="control-round-inner"><i class="fa fa-pause-circle"></i></div>
                  </div>
                </div>
                <!-- ========控制圆圈部分结束 -->
            </div>


           <!--===== 缩放部分开始 -->
            <div style="display: flex; justify-content: center; align-items: center; height: 20vw;"> 
              <div class="ptz-btn-box">
                    <div style="margin-right: 8vw;" @touchstart="ptzCamera('zoomin')" @touchend="ptzCamera('stop')" title="变倍+">
                      <i class="el-icon-zoom-in control-zoom-btn" style="font-size: 10vw; color:#78aee4 ;"></i>
                    </div>
                    <div>缩放</div>
                    <div style="" @touchstart="ptzCamera('zoomout')" @touchend="ptzCamera('stop')" title="变倍-">
                      <i class="el-icon-zoom-out control-zoom-btn" style="font-size:10vw; margin-left: 8vw; color: #78aee4;"></i>
                    </div>
              </div>
            </div>

            <!--=====底部的更多的功能菜单列表-->
            <div style="display: flex; flex-wrap: wrap; align-items: center; justify-content: flex-start;">
              <div class="menuItem" @touchstart="fullScreen"
                style=" display: flex; justify-content: center; align-items: center; flex-direction: column; box-shadow: 0 0 5px 1px #ddd; border: 1px solid #ddd;    border-radius: 1vw; "
              >
                   <svg style="margin-top: 1vw; width: 6vw; height: 6vw; " t="1739497590471" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5295" width="32" height="32"><path d="M0 0h256v51.2H0z" fill="#999999" p-id="5296"></path><path d="M51.2 0v256H0V0zM1024 0v256h-51.2V0z" fill="#999999" p-id="5297"></path><path d="M1024 51.2h-256V0h256zM1024 1024h-256v-51.2h256z" fill="#999999" p-id="5298"></path><path d="M972.8 1024v-256h51.2v256zM0 1024v-256h51.2v256z" fill="#999999" p-id="5299"></path><path d="M0 972.8h256v51.2H0z" fill="#999999" p-id="5300"></path></svg>               
                   <div style="color: #999; margin-top:2vw; font-size: 3vw;">全屏</div>
              </div>


              <div class="menuItem" @touchstart="$refs.jessibuca.playBtnClick()"
                style="display: flex; justify-content: center; align-items: center; flex-direction: column; box-shadow: 0 0 5px 1px #ddd; border: 1px solid #ddd;    border-radius: 1vw;  "
              >
                <svg t="1739757553759" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5037" width="32" height="32"><path d="M512 42.666667C252.793333 42.666667 42.666667 252.793333 42.666667 512s210.126667 469.333333 469.333333 469.333333 469.333333-210.126667 469.333333-469.333333S771.206667 42.666667 512 42.666667z m0 896c-235.64 0-426.666667-191.026667-426.666667-426.666667s191.026667-426.666667 426.666667-426.666667 426.666667 191.026667 426.666667 426.666667-191.026667 426.666667-426.666667 426.666667z m-74.666667-213.38a53.373333 53.373333 0 0 1-53.333333-53.333334V352.066667A53.333333 53.333333 0 0 1 467.373333 308L702 467.933333a53.333333 53.333333 0 0 1 0 88.133334L467.373333 716a53.286667 53.286667 0 0 1-30.04 9.286667z m0.08-383.933334a11.093333 11.093333 0 0 0-5.08 1.28 10.446667 10.446667 0 0 0-5.666666 9.433334v319.866666a10.666667 10.666667 0 0 0 16.666666 8.82l234.666667-159.94a10.666667 10.666667 0 0 0 0-17.626666l-234.666667-159.933334a10.313333 10.313333 0 0 0-5.906666-1.92z" fill="#999999" p-id="5038"></path></svg>
                
                <div style="color: #999; margin-top:2vw; font-size: 3vw;">播放</div>
              </div>


              <div class="menuItem"  @touchstart="$refs.jessibuca.destroy()"
                style="display: flex; justify-content: center; align-items: center; flex-direction: column; box-shadow: 0 0 5px 1px #ddd; border: 1px solid #ddd;    border-radius: 1vw; "
              >
                <svg t="1739757721808" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6161" width="32" height="32"><path d="M512 1024C228.266667 1024 0 795.733333 0 512S228.266667 0 512 0s512 228.266667 512 512-228.266667 512-512 512z m0-42.666667c260.266667 0 469.333333-209.066667 469.333333-469.333333S772.266667 42.666667 512 42.666667 42.666667 251.733333 42.666667 512s209.066667 469.333333 469.333333 469.333333z m-106.666667-682.666666c12.8 0 21.333333 8.533333 21.333334 21.333333v384c0 12.8-8.533333 21.333333-21.333334 21.333333s-21.333333-8.533333-21.333333-21.333333V320c0-12.8 8.533333-21.333333 21.333333-21.333333z m213.333334 0c12.8 0 21.333333 8.533333 21.333333 21.333333v384c0 12.8-8.533333 21.333333-21.333333 21.333333s-21.333333-8.533333-21.333334-21.333333V320c0-12.8 8.533333-21.333333 21.333334-21.333333z" fill="#999999" fill-opacity=".9" p-id="6162"></path></svg>                 
              
                <div style="color: #999; margin-top:2vw; font-size: 3vw;">暂停</div>
              </div>

              <div class="menuItem"
                @touchstart = "backVideo"
                style="display: flex; justify-content: center; align-items: center; flex-direction: column; box-shadow: 0 0 5px 1px #ddd; border: 1px solid #ddd;    border-radius: 1vw;"
              >
                 <svg t="1739758035901" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10748" width="32" height="32"><path d="M715.642085 318.678466H308.609636a61.419862 61.419862 0 0 0-61.419862 61.168142v264.306784A61.419862 61.419862 0 0 0 308.609636 704.818092h407.032449a61.168142 61.168142 0 0 0 61.168141-61.419862V379.846608a61.168142 61.168142 0 0 0-61.168141-61.168142z m30.961651 325.474926a31.213373 31.213373 0 0 1-30.961651 31.213373H308.609636A31.465093 31.465093 0 0 1 276.892822 644.153392v-264.306784a31.213373 31.213373 0 0 1 31.213373-30.961652h407.53589a30.961652 30.961652 0 0 1 30.961651 30.961652z" fill="#999999" p-id="10749"></path><path d="M599.095379 485.821042l-109.246805-63.181907a29.954769 29.954769 0 0 0-30.45821 0 29.703048 29.703048 0 0 0-15.103245 25.172074v125.860374a30.20649 30.20649 0 0 0 30.20649 30.458211 30.45821 30.45821 0 0 0 15.354965-4.027532l109.246805-63.181908a30.20649 30.20649 0 0 0 15.354965-26.430678 29.954769 29.954769 0 0 0-15.354965-24.668634z m-12.586038 30.709931L478.26942 578.957719a5.537856 5.537856 0 0 1-5.286136 0 4.782694 4.782694 0 0 1-2.517207-4.530974v-125.860373a5.034415 5.034415 0 0 1 2.517207-4.530974 6.041298 6.041298 0 0 1 2.517208 0H478.26942l109.246804 63.181908a5.286136 5.286136 0 0 1 2.768928 4.530973 5.034415 5.034415 0 0 1-3.775811 4.782694z" fill="#999999" p-id="10750"></path><path d="M512 0a512 512 0 1 0 512.251721 512A512.755162 512.755162 0 0 0 512 0z m0 998.827925a486.827925 486.827925 0 1 1 487.079646-486.827925 487.331367 487.331367 0 0 1-487.079646 486.827925z" fill="#999999" p-id="10751"></path></svg>
                 <div style="color: #999; margin-top:2vw; font-size: 3vw;">回看</div>
              </div>


              <div class="menuItem" @touchstart="changeVio()"
                style="display: flex; justify-content: center; align-items: center; flex-direction: column; box-shadow: 0 0 5px 1px #ddd; border: 1px solid #ddd;    border-radius: 1vw;"
              >
                 <svg v-if="hasVio" t="1740213984445" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1084" width="32" height="32"><path d="M524.8 149.333333h-2.133333c-8.533333 0-17.066667 2.133333-25.6 8.533334-125.866667 108.8-192 166.4-198.4 172.8H196.266667c-12.8 0-23.466667 4.266667-32 12.8-10.666667 10.666667-14.933333 21.333333-14.933334 32v277.333333c0 12.8 4.266667 23.466667 12.8 32 8.533333 8.533333 19.2 12.8 32 12.8H298.666667c2.133333 2.133333 21.333333 19.2 53.333333 46.933333 32 27.733333 66.133333 55.466667 96 81.066667 32 25.6 46.933333 40.533333 49.066667 40.533333 8.533333 6.4 17.066667 8.533333 25.6 8.533334h2.133333c17.066667-2.133333 27.733333-12.8 32-32v-661.333334c-4.266667-19.2-14.933333-29.866667-32-32z m-8.533333 676.266667c-6.4-4.266667-198.4-170.666667-198.4-170.666667H194.133333V371.2h123.733334s46.933333-42.666667 198.4-174.933333v629.333333zM776.533333 512l89.6-89.6c8.533333-8.533333 8.533333-21.333333 0-29.866667s-21.333333-8.533333-29.866666 0L746.666667 482.133333l-89.6-89.6c-8.533333-8.533333-21.333333-8.533333-29.866667 0s-8.533333 21.333333 0 29.866667l89.6 89.6-89.6 89.6c-8.533333 8.533333-8.533333 21.333333 0 29.866667s21.333333 8.533333 29.866667 0l89.6-89.6 89.6 89.6c8.533333 8.533333 21.333333 8.533333 29.866666 0s8.533333-21.333333 0-29.866667L776.533333 512z" fill="#999999" p-id="1085"></path></svg>
                 <svg v-else t="1740214053693" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1374" width="32" height="32"><path d="M535.466667 149.333333H533.333333c-8.533333 0-17.066667 2.133333-25.6 8.533334-125.866667 108.8-192 166.4-198.4 172.8H204.8c-12.8 0-23.466667 4.266667-32 12.8-8.533333 8.533333-12.8 19.2-12.8 32v277.333333c0 12.8 4.266667 23.466667 12.8 32 8.533333 8.533333 19.2 12.8 32 12.8h102.4c2.133333 2.133333 21.333333 19.2 53.333333 46.933333 32 27.733333 66.133333 55.466667 96 81.066667 32 25.6 46.933333 40.533333 49.066667 40.533333 8.533333 6.4 17.066667 8.533333 25.6 8.533334h2.133333c17.066667-2.133333 27.733333-12.8 32-32v-661.333334c-2.133333-19.2-12.8-29.866667-29.866666-32z m-10.666667 676.266667c-6.4-4.266667-198.4-170.666667-198.4-170.666667H202.666667V371.2h123.733333s46.933333-42.666667 198.4-174.933333v629.333333z m262.4-535.466667c-8.533333-10.666667-21.333333-10.666667-32-2.133333-8.533333 8.533333-8.533333 19.2-2.133333 27.733333 42.666667 53.333333 68.266667 121.6 68.266666 196.266667 0 74.666667-25.6 142.933333-68.266666 196.266667-6.4 8.533333-6.4 19.2 2.133333 27.733333s23.466667 8.533333 32-2.133333c49.066667-61.866667 76.8-138.666667 76.8-224s-29.866667-157.866667-76.8-219.733334z m-123.733333 89.6c-8.533333 8.533333-8.533333 19.2-4.266667 25.6 21.333333 29.866667 32 68.266667 32 106.666667 0 40.533333-12.8 76.8-32 106.666667-6.4 8.533333-4.266667 19.2 2.133333 25.6 8.533333 8.533333 23.466667 8.533333 32-2.133334 25.6-38.4 40.533333-83.2 40.533334-130.133333 0-49.066667-14.933333-93.866667-40.533334-130.133333-4.266667-10.666667-19.2-12.8-29.866666-2.133334z" fill="#999999" p-id="1375"></path></svg>
                 <div style="color: #999; margin-top:2vw; font-size: 3vw;">声音</div>
              </div>
              


            </div>
            <!-- =====缩放部分结束 -->
          <!-- </el-tab-pane> -->

          <!-- 云台控制部分结束 -->




          <!-- =========语音对讲部分开始========== -->
          <!-- <el-tab-pane label="语音对讲" name="broadcast">
            <div style="padding: 0 10px">
              <el-switch v-model="broadcastMode" :disabled="broadcastStatus !== -1" active-color="#409EFF"
                         active-text="喊话(Broadcast)"
                         inactive-text="对讲(Talk)"></el-switch>
            </div>
            <div class="trank" style="text-align: center;">
              <el-button @click="broadcastStatusClick()" :type="getBroadcastStatus()" :disabled="broadcastStatus === -2"
                         circle icon="el-icon-microphone" style="font-size: 32px; padding: 24px;margin-top: 24px;"/>
              <p>
                <span v-if="broadcastStatus === -2">正在释放资源</span>
                <span v-if="broadcastStatus === -1">点击开始对讲</span>
                <span v-if="broadcastStatus === 0">等待接通中...</span>
                <span v-if="broadcastStatus === 1">请说话</span>
              </p>
            </div>  
          </el-tab-pane> -->
          <!-- =============语音对讲部分结束============  -->

        </el-tabs>
      </div>
  </div>
</div>
</template>


<script>
import rtcPlayer from '../dialog/rtcPlayer.vue'
import LivePlayer from '@liveqing/liveplayer'
import crypto from 'crypto'
import jessibucaPlayer from '../common/jessibuca.vue'
import PtzPreset from "../common/ptzPreset.vue";
import PtzCruising from "../common/ptzCruising.vue";
import ptzScan from "../common/ptzScan.vue";
import ptzWiper from "../common/ptzWiper.vue";
import ptzSwitch from "../common/ptzSwitch.vue";
import mediaInfo from "../common/mediaInfo.vue";


// import crypto from 'crypto'
import userService from "@/components/service/UserService";
import { title } from 'process';

export default {
  name: 'devicePlayer',
  props: {},
  components: {
    PtzPreset,PtzCruising,ptzScan,ptzWiper,ptzSwitch,mediaInfo,
    LivePlayer, jessibucaPlayer, rtcPlayer,
  },
  computed: {
    getPlayerShared: function () {
      return {
        sharedUrl: window.location.origin + '/#/play/wasm/' + encodeURIComponent(this.videoUrl),
        sharedIframe: '<iframe src="' + window.location.origin + '/#/play/wasm/' + encodeURIComponent(this.videoUrl) + '"></iframe>',
        sharedRtmp: this.videoUrl
      };
    }
  },
  created() {
    //测试直接通过设备和通道id 播放
    //  this.sendDevicePush();
    //初始化
    // this.openDialog();
    //判断是都登录
    //获取url 参数
    let title =  this.$route.query.name;
    if(title){
      this.title = title;
      document.title = title
    }

    let client = this.$route.query.client
    this.client = client;
    // if(userService.getToken()){

    this.init()  
    // }else{
       //===每次进来都自动登录，避免token过期，发挥错误数据
      //  this.toLogin();
    // }

    const script = document.createElement('script');
    script.src = '/static/js/webview.js';
    script.onload = () => {
      console.log('========================uni.webview.js loaded');
      // 确保 uni API 可用
      document.addEventListener('UniAppJSBridgeReady', () => {
        console.log('=====================UniAppJSBridge is ready');
      });
    };
    document.head.appendChild(script);
  },
  data() {
    return {
      isFull:"nofull",
      client:"",
      title:"监控",
      showBack:false,
      video: 'http://lndxyj.iqilu.com/public/upload/2019/10/14/8c001ea0c09cdc59a57829dabc8010fa.mp4',
      videoUrl: '',
      activePlayer: "jessibuca",
      // 如何你只是用一种播放器，直接注释掉不用的部分即可
      player: {
        jessibuca: ["ws_flv", "wss_flv"],
        webRTC: ["rtc", "rtcs"],
      },
      showVideoDialog: false,
      streamId: '',
      ptzMethod: 'preset',
      ptzPresetId: '',
      app: '',
      mediaServerId: '',
      deviceId: '34020000001110070200',
      channelId: '34020000001320070210', 
      tabActiveName: 'showPtz',
      hasAudio: false,
      loadingRecords: false,
      recordsLoading: false,
      isLoging: false,
      controSpeed: 30,
      timeVal: 0,
      timeMin: 0,
      timeMax: 1440,
      presetPos: 1,
      cruisingSpeed: 100,
      cruisingTime: 5,
      cruisingGroup: 0,
      scanSpeed: 100,
      scanGroup: 0,
      tracks: [],
      tracksLoading: false,
      showPtz: true,
      showRrecord: true,
      tracksNotLoaded: false,
      sliderTime: 0,
      seekTime: 0,
      recordStartTime: 0,  
      showTimeText: "00:00:00",
      streamInfo: null,
      broadcastMode: true,
      broadcastRtc: null,
      broadcastStatus: -1, // -2 正在释放资源 -1 默认状态 0 等待接通 1 接通成功
      hasVio:false,
    };
  },
  methods: {
    
    goBack(){
      uni.navigateBack();
    },
    //跳转到回看录像页面
    backVideo(){
      // let baseUrl = window.location.protocol + "//" + window.location.host;
      // console.log(baseUrl)
      this.$router.push(`/gbRecordDetailMobile/${this.deviceId}/${this.channelId}?type=wx&name=${this.title}&client=${this.client}`)
      //http://121.43.228.179:30021/#/gbRecordDetailMobile/34020000001110140100/34020000001320140115
      //获取当前项目的url 和端口部分
    },
    //切换声音
    changeVio(){
      if(this.$refs.jessibuca.isNotMute){
        this.$refs.jessibuca.mute();
        this.hasVio = true;
      }else{
        this.$refs.jessibuca.cancelMute();
        this.hasVio = false;
      }
    },
    //全屏操作方法
    fullScreen(){
       //打开全屏
       this.$refs.jessibuca.fullscreenSwich();
       this.isFull = "full";
       this.showBack = true;
    },
    // refresh(){
    //   window.location.reload();
    // },
    //页面初始化操作
    init(){
      console.log("created")
      console.log(this.player)
      this.broadcastStatus = -1;
      if (Object.keys(this.player).length === 1) {
        this.activePlayer = Object.keys(this.player)[0]
      }

      this.deviceId = this.$route.params.deviceId;
      this.channelId = this.$route.params.channelId;

      //添加一个处理操作 
      this.sendDevicePush();

      setTimeout(() => {
        console.log(this.videoUrl)
      }, 2000);
    },
  	toLogin(){
  		//需要想后端发送的登录参数
  		// let loginParam = {
  		// 	username: 'admin',
  		// 	password: crypto.createHash('md5').update('gao123456', "utf8").digest('hex')
  		// }
      var that = this;
      //设置在登录状态
      // this.isLoging = true;
      // let timeoutTask = setTimeout(()=>{
      //   that.$message.error("登录超时");
      //   that.isLoging = false;
      // }, 1000)

      this.$axios({
      	method: 'get',
        url:"/api/user/login",
        params: loginParam
      }).then(function (res) {
          // window.clearTimeout(timeoutTask)
          console.log(res);
          console.log("登录成功");
          if (res.data.code === 0 ) {
            userService.setUser(res.data.data)
            that.init();
            // window.location.reload();
           
            //登录成功后
            // that.cancelEnterkeyDefaultAction();
            //判断用户。如果是某个用户那么跳转到liveOne 页面
            // if(that.username == 'quanguoguancha'){
            //   that.$router.push('/liveOne');
            // }else{
            //   that.$router.push('/');
            // }
          }else{
            // that.isLoging = false;
            // that.$message({
            //       showClose: true,
            //       message: '登录失败，用户名或密码错误',
            //       type: 'error'
            // });
          }
      }).catch(function (error) {
        console.log(error)
        // window.clearTimeout(timeoutTask)
        // that.$message.error(error.response.data.msg);
        // that.isLoging = false;
      });
    },  
    //通知开始推流
    //34020000001110120301/34020000001320000001
    sendDevicePush:function () {

      let deviceId  = this.deviceId;;
      let channelId = this.channelId;
      console.log("通知设备推流1：" + deviceId + " : " + channelId);
      let that = this;
      this.$axios({
        method: 'get',
        url: '/api/play/start/' + deviceId + '/' + channelId,
        params: {
          isSubStream: false
        }
      }).then(function (res) {
        console.log(res)
        that.isLoging = false;
        if (res.data.code === 0) {
          // setTimeout(() => {
          //   let snapId = deviceId + "_" + channelId;
          //   that.loadSnap[deviceId + channelId] = 0;
          //   that.getSnapErrorEvent(snapId)
          // }, 5000)
          // itemData.streamId = res.data.data.stream;
          that.openDialog("media", deviceId, channelId, {
            streamInfo: res.data.data,
            hasAudio: true
          });
          // setTimeout(() => {
          //   that.initData();
          // }, 1000)

        } else {
          that.$message.error(res.data.msg);
        }
      }).catch(function (e) {
        console.error(e)
        that.isLoging = false;
        // that.$message.error("请求超时");
      });
    },
    tabHandleClick: function (tab, event) {
      console.log(tab)
      var that = this;
      that.tracks = [];
      that.tracksLoading = true;
      that.tracksNotLoaded = false;
      if (tab.name === "codec") {
        this.$axios({
          method: 'get',
          url: '/zlm/' + this.mediaServerId + '/index/api/getMediaInfo?vhost=__defaultVhost__&schema=rtsp&app=' + this.app + '&stream=' + this.streamId
        }).then(function (res) {
          that.tracksLoading = false;
          if (res.data.code == 0 && res.data.tracks) {
            that.tracks = res.data.tracks;
          } else {
            that.tracksNotLoaded = true;
            that.$message({
              showClose: true,
              message: '获取编码信息失败,',
              type: 'warning'
            });
          }
        }).catch(function (e) {
        });
      }
    },
    changePlayer: function (tab) {
      console.log(this.player[tab.name][0])
      this.activePlayer = tab.name;
      this.videoUrl = this.getUrlByStreamInfo()
      console.log(this.videoUrl)
    },
    openDialog: function (tab, deviceId, channelId, param) {
      if (this.showVideoDialog) {
        return;
      }
      this.tabActiveName = tab;
      this.channelId = channelId;
      this.deviceId = deviceId;
      this.streamId = "";
      this.mediaServerId = "";
      this.app = "";
      this.videoUrl = ""
      if (!!this.$refs[this.activePlayer]) {
        this.$refs[this.activePlayer].pause();
      }
      switch (tab) {
        case "media":
          this.play(param.streamInfo, param.hasAudio)
          break;
        case "streamPlay":
          this.tabActiveName = "media";
          this.showRrecord = false;
          this.showPtz = false;
          this.play(param.streamInfo, param.hasAudio)
          break;
        case "control":
          break;
      }
    },
    play: function (streamInfo, hasAudio) {
      this.streamInfo = streamInfo;
      this.hasAudio = hasAudio;
      this.isLoging = false;
      // this.videoUrl = streamInfo.rtc;
      this.videoUrl = this.getUrlByStreamInfo();
      this.streamId = streamInfo.stream;
      this.app = streamInfo.app;
      this.mediaServerId = streamInfo.mediaServerId;
      this.playFromStreamInfo(false, streamInfo)
    },
    getUrlByStreamInfo() {
      console.log(this.streamInfo)
      let streamInfo = this.streamInfo
      if (this.streamInfo.transcodeStream) {
        streamInfo = this.streamInfo.transcodeStream;
      }
      if (location.protocol === "https:") {
        let videoUrl = streamInfo[this.player[this.activePlayer][1]]
        this.videoUrl = this.replaceUrlIPWithDomain(videoUrl);
      } else {
        let videoUrl = streamInfo[this.player[this.activePlayer][0]]
        this.videoUrl = this.replaceUrlIPWithDomain(videoUrl);
      }
      return this.videoUrl;
    },

        playFromStreamInfo: function (realHasAudio, streamInfo) {
          this.showVideoDialog = true;
          this.hasaudio = realHasAudio && this.hasaudio;
          if (this.$refs[this.activePlayer]) {
            this.$refs[this.activePlayer].play(this.getUrlByStreamInfo(streamInfo))
          }else {
            this.$nextTick(() => {
              this.$refs[this.activePlayer].play(this.getUrlByStreamInfo(streamInfo))
            });
          }
        },
        close: function () {
            console.log('关闭视频');
            if (!!this.$refs[this.activePlayer]){
              this.$refs[this.activePlayer].pause();
            }
            this.videoUrl = '';
            this.coverPlaying = false;
            this.showVideoDialog = false;
            this.stopBroadcast()
        },

    copySharedInfo: function (data) {
      console.log('复制内容：' + data);
      this.coverPlaying = false;
      this.tracks = []
      let _this = this;
      this.$copyText(data).then(
          function (e) {
            _this.$message({
              showClose: true,
              message: '复制成功',
              type: 'success'
            });
          },
          function (e) {
            _this.$message({
              showClose: true,
              message: '复制失败，请手动复制',
              type: 'error'
            });
          }
      );
    },
    ptzCamera: function (command) {
      console.log('云台控制：' + command);
      let that = this;
      this.$axios({
        method: 'get',
        url: '/api/front-end/ptz/' + this.deviceId + '/' + this.channelId + '?command=' + command + '&horizonSpeed=' + parseInt(this.controSpeed * 255/100) + '&verticalSpeed=' + parseInt(this.controSpeed * 255/100) + '&zoomSpeed=' + parseInt(this.controSpeed * 16/100)
      }).then(function (res) {
      });
    },
    irisCamera: function (command) {
      this.$axios({
        method: 'get',
        url: '/api/front-end/fi/iris/' + this.deviceId + '/' + this.channelId + '?command=' + command + '&speed=' + parseInt(this.controSpeed * 255/100)
      }).then(function (res) {
      });
    },
    focusCamera: function (command) {
      this.$axios({
        method: 'get',
        url: '/api/front-end/fi/focus/' + this.deviceId + '/' + this.channelId + '?command=' + command + '&speed=' + parseInt(this.controSpeed * 255/100)
      }).then(function (res) {
      });
    },
    //////////////////////播放器事件处理//////////////////////////
    videoError: function (e) {
      console.log("播放器错误：" + JSON.stringify(e));
    },
    copyUrl: function (dropdownItem) {
      console.log(dropdownItem)
      this.$copyText(dropdownItem).then((e) => {
        this.$message.success({
          showClose: true,
          message: "成功拷贝到粘贴板"
        })
      }, (e) => {

      })
    },
    getBroadcastStatus() {
      if (this.broadcastStatus == -2) {
        return "primary"
      }
      if (this.broadcastStatus == -1) {
        return "primary"
      }
      if (this.broadcastStatus == 0) {
        return "warning"
      }
      if (this.broadcastStatus == 1) {
        return "danger"
      }

    },
    broadcastStatusClick() {
      if (this.broadcastStatus == -1) {
        // 默认状态， 开始
        this.broadcastStatus = 0
        // 发起语音对讲
        this.$axios({
          method: 'get',
          url: '/api/play/broadcast/' + this.deviceId + '/' + this.channelId + "?timeout=30&broadcastMode=" + this.broadcastMode
        }).then((res) => {
          if (res.data.code === 0) {
            let streamInfo = res.data.data.streamInfo;
            if (document.location.protocol.includes("https")) {
              this.startBroadcast(streamInfo.rtcs)
            } else {
              this.startBroadcast(streamInfo.rtc)
            }
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: "error",
            });
          }
        });
      } else if (this.broadcastStatus === 1) {
        this.broadcastStatus = -1;
        this.broadcastRtc.close()
      }
    },
    startBroadcast(url) {
      // 获取推流鉴权Key
      this.$axios({
        method: 'post',
        url: '/api/user/userInfo',
      }).then((res) => {
        if (res.data.code !== 0) {
          this.$message({
            showClose: true,
            message: "获取推流鉴权Key失败",
            type: "error",
          });
          this.broadcastStatus = -1;
        } else {
          let pushKey = res.data.data.pushKey;
          // 获取推流鉴权KEY
          url += "&sign=" + crypto.createHash('md5').update(pushKey, "utf8").digest('hex')
          console.log("开始语音喊话： " + url)
          this.broadcastRtc = new ZLMRTCClient.Endpoint({
            debug: true, // 是否打印日志
            zlmsdpUrl: url, //流地址
            simulecast: false,
            useCamera: false,
            audioEnable: true,
            videoEnable: false,
            recvOnly: false,
          })

          this.broadcastRtc.on(ZLMRTCClient.Events.WEBRTC_NOT_SUPPORT, (e) => {// 获取到了本地流
            console.error('不支持webrtc', e)
            this.$message({
              showClose: true,
              message: '不支持webrtc, 无法进行语音喊话',
              type: 'error'
            });
            this.broadcastStatus = -1;
          });

          this.broadcastRtc.on(ZLMRTCClient.Events.WEBRTC_ICE_CANDIDATE_ERROR, (e) => {// ICE 协商出错
            console.error('ICE 协商出错')
            this.$message({
              showClose: true,
              message: 'ICE 协商出错',
              type: 'error'
            });
            this.broadcastStatus = -1;
          });

          this.broadcastRtc.on(ZLMRTCClient.Events.WEBRTC_OFFER_ANWSER_EXCHANGE_FAILED, (e) => {// offer anwser 交换失败
            console.error('offer anwser 交换失败', e)
            this.$message({
              showClose: true,
              message: 'offer anwser 交换失败' + e,
              type: 'error'
            });
            this.broadcastStatus = -1;
          });
          this.broadcastRtc.on(ZLMRTCClient.Events.WEBRTC_ON_CONNECTION_STATE_CHANGE, (e) => {// offer anwser 交换失败
            console.log('状态改变', e)
            if (e === "connecting") {
              this.broadcastStatus = 0;
            } else if (e === "connected") {
              this.broadcastStatus = 1;
            } else if (e === "disconnected") {
              this.broadcastStatus = -1;
            }
          });
          this.broadcastRtc.on(ZLMRTCClient.Events.CAPTURE_STREAM_FAILED, (e) => {// offer anwser 交换失败
            console.log('捕获流失败', e)
            this.$message({
              showClose: true,
              message: '捕获流失败' + e,
              type: 'error'
            });
            this.broadcastStatus = -1;
          });
        }
      }).catch((e) => {
        this.$message({
          showClose: true,
          message: e,
          type: 'error'
        });
        this.broadcastStatus = -1;
      });


    },
    stopBroadcast() {
      this.broadcastRtc.close();
      this.broadcastStatus = -1;
      this.$axios({
        method: 'get',
        url: '/api/play/broadcast/stop/' + this.deviceId + '/' + this.channelId
      }).then((res) => {
        if (res.data.code == 0) {
          // this.broadcastStatus = -1;
          // this.broadcastRtc.close()
        } else {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type: "error",
          });
        }
      });
    }
  }
};
</script>


<style scoped>
  /* html,body{ 
    border: 2px solid darkcyan;
    height: 100vh;
    width: 100vw;  
    background:red;
  } */


  .noSelect{
            -webkit-user-select: none; /* Safari */
            -moz-user-select: none; /* Firefox */
            -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* 标准语法 */
        }

  .menuItem{
    /* margin: 2%; */
    margin: 2%;
    box-sizing: border-box;
    flex-basis: 21%;  
    height: 20vw; 
  }

.control-wrapper {
  position: relative;
  width: 50vw; 
  height: 50vw;
  /* max-width: 6.25rem; */
  /* max-height: 6.25rem; */
  border-radius: 100%;
  margin-top: 2vw;   
  /* margin-left: 0.5rem; */
  /* float: left; */
}

.control-panel {
  position: relative;
  top: 0;
  left: 5rem;
  height: 11rem;
  max-height: 11rem;
}

.control-btn {
  display: flex;
  justify-content: center;
  position: absolute;
  width: 44%;
  height: 44%;
  border-radius: 5px;
  border: 1px solid #78aee4;
  box-sizing: border-box;
  transition: all 0.3s linear;
}

.control-btn:hover {
  cursor: pointer
}

.control-btn i {
  font-size: 10vw;
  color: #78aee4;
  display: flex;
  justify-content: center;
  align-items: center;
}

.control-btn i:hover {
  cursor: pointer
}

.control-zoom-btn:hover {
  cursor: pointer
}

.control-round {
  position: absolute;
  top: 21%;
  left: 21%;
  width: 58%;
  height: 58%;
  background: #fff;
  border-radius: 100%;
}

.control-round-inner {
  position: absolute;
  left: 13%;
  top: 13%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70%;
  height: 70%;
  font-size: 40px;
  color: #78aee4;
  border: 1px solid #78aee4;
  border-radius: 100%;
  transition: all 0.3s linear;
}

.control-inner-btn {
  position: absolute;
  width: 60%;
  height: 60%;
  background: #fafafa;
}

.control-top {
  top: -8%;
  left: 27%;
  transform: rotate(-45deg);
  border-radius: 5px 100% 5px 0;
}

.control-top i {
  transform: rotate(45deg);
  border-radius: 5px 100% 5px 0;
}

.control-top .control-inner {
  left: -1px;
  bottom: 0;
  border-top: 1px solid #78aee4;
  border-right: 1px solid #78aee4;
  border-radius: 0 100% 0 0;
}

.control-top .fa {
  transform: rotate(45deg) translateY(-7px);
}

.control-left {
  top: 27%;
  left: -8%;
  transform: rotate(45deg);
  border-radius: 5px 0 5px 100%;
}

.control-left i {
  transform: rotate(-45deg);
}

.control-left .control-inner {
  right: -1px;
  top: -1px;
  border-bottom: 1px solid #78aee4;
  border-left: 1px solid #78aee4;
  border-radius: 0 0 0 100%;
}

.control-left .fa {
  transform: rotate(-45deg) translateX(-7px);
}

.control-right {
  top: 27%;
  right: -8%;
  transform: rotate(45deg);
  border-radius: 5px 100% 5px 0;
}

.control-right i {
  transform: rotate(-45deg);
}

.control-right .control-inner {
  left: -1px;
  bottom: -1px;
  border-top: 1px solid #78aee4;
  border-right: 1px solid #78aee4;
  border-radius: 0 100% 0 0;
}

.control-right .fa {
  transform: rotate(-45deg) translateX(7px);
}

.control-bottom {
  left: 27%;
  bottom: -8%;
  transform: rotate(45deg);
  border-radius: 0 5px 100% 5px;
}

.control-bottom i {
  transform: rotate(-45deg);
}

.control-bottom .control-inner {
  top: -1px;
  left: -1px;
  border-bottom: 1px solid #78aee4;
  border-right: 1px solid #78aee4;
  border-radius: 0 0 100% 0;
}

.control-bottom .fa {
  transform: rotate(-45deg) translateY(7px);
}

.trank {
  width: 80%;
  height: 180px;
  text-align: left;
  padding: 0 10%;
  overflow: auto;
}

.trankInfo {
  width: 80%;
  padding: 0 10%;
}
.el-dialog__body{
  padding: 10px 20px;
}
.ptz-btn-box {
  /* display: grid; */
  /* grid-template-columns: 1fr 1fr; */
  /* padding: 0 2rem; */
  display: flex;
  color: #78aee4;
  align-items: center;
  /* height: 5vw; */
  /* width: 5vw; */
  line-height: 5vw;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/mobilePlay.vue